import { render, staticRenderFns } from "./LikesOverview.vue?vue&type=template&id=059efb0c&scoped=true"
import script from "./LikesOverview.vue?vue&type=script&lang=js"
export * from "./LikesOverview.vue?vue&type=script&lang=js"
import style0 from "./LikesOverview.vue?vue&type=style&index=0&id=059efb0c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059efb0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('059efb0c')) {
      api.createRecord('059efb0c', component.options)
    } else {
      api.reload('059efb0c', component.options)
    }
    module.hot.accept("./LikesOverview.vue?vue&type=template&id=059efb0c&scoped=true", function () {
      api.rerender('059efb0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LikesOverview.vue"
export default component.exports